import { Vector4 } from "three";
import RectangleMesh from "../../instancing/Meshes/RectangleMesh";
import RectangleOutlineMesh from "../../instancing/Meshes/RectOutlineMesh";
import getMaterialWithUniforms from "../../instancing/materials/getMaterialWithUniforms";
import { frequencyDbs } from "../../constants/dbs";
import createTriangleTexture from "../../instancing/textures/createTriangleTexture";
import ParticleMesh from "../../instancing/Meshes/ParticleMesh";
import DbCategoryColorScale from "../../models/DbCategoryColorScale";

const pointSize = 8;

const dbs = Object.values(frequencyDbs);
const triangleText = createTriangleTexture({ size: pointSize });

export const colorMap = new DbCategoryColorScale(dbs);

export function getVariantMesh() {
  const conf = {
    rgbaCode: 1,
    raycastInd: 1,
    posX: 1,
    posY: 1,
  };

  const materialConf = getMaterialWithUniforms({})
    .setPaddingX([-0.5, 0.5, -0.5, 0.5])
    .setPaddingY([-3, -3, 3, 3])
    .setOffset([0, 0])
    .setColorMap(colorMap.calc().vectors);

  return new RectangleMesh(materialConf, conf);
}

export function getDeletionMesh() {
  const conf = {
    rgbaCode: 1,
    raycastInd: 1,
    posX: 1,
    posY: 1,
  };
  const materialConf = getMaterialWithUniforms({})
    .setPaddingX([-0.5, 0.5, -0.5, 0.5])
    .setPaddingY([-3, -3, 3, 3])
    .setOffset([0, 0])
    .setBorderWidth(1)
    .setRaycastBorderWidth(5)
    .setColorMap(colorMap.calc().vectors);

  return new RectangleOutlineMesh(materialConf, conf);
}

export function getAdditionMesh() {
  const conf = {
    rgbaCode: 1,
    posX: 1,
    posY: 1,
  };
  const materialConf = getMaterialWithUniforms({
    alphaTest: 0.5,
    transparent: true,
    depthWrite: false,
    depthTest: false,
  })
    .setOffset([0, 0])
    .setColorMap(colorMap.calc().vectors)
    .setPointSize(pointSize)
    .setTexture(triangleText.texture)
    .setTextureCoordMap(triangleText.textureCoordsMap);

  return new ParticleMesh(materialConf, conf);
}

export function getSelectionMesh() {
  const conf = {
    rgbaCode: 1,
    posX: 1,
    posY: 1,
  };
  const materialConf = getMaterialWithUniforms({
    transparent: true,
    disableRaycast: true,
  })
    .setPaddingX([-4, 4, -4, 4])
    .setPaddingY([-6, -6, 6, 6])
    .setOffset([0, 0])
    .setBorderWidth(1)
    .setColorMap([new Vector4(0.5, 0.4, 0, 1)]);

  return new RectangleOutlineMesh(materialConf, conf);
}

export function updateVis(items, mesh, hasFilters) {
  const setY = mesh.updateY({ count: items.length, isAppend: false });
  for (let i = 0; i < items.length; i++) {
    const { hidden, freq } = items[i];
    const y = hasFilters && hidden ? -5000 : freq;
    setY(i, y, y, y, y);
  }
}

export function drawVariant(items, mesh, hasFilters, padding) {
  const count = items.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setY = mesh.updateY({ count, isAppend });
  const setRgb = mesh.updateRgba({ count, isAppend });
  for (let i = 0; i < count; i++) {
    const { hidden, freq } = items[i];
    const y = hasFilters && hidden ? -5000 : freq;
    const { g0, g1 } = items[i].variant.region;
    const p = g0 === g1 ? -padding : padding;
    const x0 = g0 + p;
    const x1 = g1 - p;
    const rgb = colorMap.getKey(items[i].db.key).ind;

    setX(i, x0, x1, x0, x1);
    setY(i, y, y, y, y);
    setRgb(i, rgb, rgb, rgb, rgb);
  }
}

export function drawSelection(items, mesh, hasFilters, padding) {
  const count = items.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setY = mesh.updateY({ count, isAppend });
  const setRgb = mesh.updateRgba({ count, isAppend });
  for (let i = 0; i < count; i++) {
    const { hidden, freq } = items[i];
    const y = hasFilters && hidden ? -5000 : freq;
    const { g0, g1 } = items[i].variant.region;
    const p = g0 === g1 ? -padding : padding;
    const x0 = g0 + p;
    const x1 = g1 - p;

    setX(i, x0, x1, x0, x1);
    setY(i, y, y, y, y);
    setRgb(i, 0, 0, 0, 0);
  }
}
